module.exports = __webpack_public_path__ + "images/花筑奢pr长图_08-4.jpg?v=678c6ee4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_08-4.jpg
 ** module id = 47
 ** module chunks = 1 2
 **/